export default "__VITE_ASSET__BH8ttwE0__"